import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { StakingProcess, StakingActionType } from "@modules/staking/domain/entities/staking-process.model";
import { Fiat } from "@models";
import { Observable } from "rxjs";
import { StakingFacade } from "@modules/staking/domain/+state/staking.facade";
import { TradeAmountType } from "@modules/shared/domain/entities/trade-amount-type.model";
import { StakingHelperService } from "@modules/staking/domain/+state/utility/staking-helper.service";

@Component({
	selector: "app-stake-pending-screen",
	templateUrl: "./pending-screen.component.html",
	styleUrls: ["./pending-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class PendingScreenComponent {
	@Input() public defaultFiat: Fiat = this.stakingHelperService.getFiat();
	public stakingProcess$: Observable<StakingProcess> = this.stakingFacade.getStakingProcess$();
	public stakeType: StakingActionType = StakingActionType.STAKE;
	public tradeAmountTypes: typeof TradeAmountType = TradeAmountType;

	public constructor(
		private stakingFacade: StakingFacade,
		private stakingHelperService: StakingHelperService
	) {}
}
